const constants = {
    Kelvin: 273.15,
    Patm: 101.325, // kPa
    Ra: 287.055, // J/(kg.K)
    Mm: 0.62198,
    C1: -5800.2206,
    C2: 1.3914993,
    C3: -0.048640239,
    C4: 0.000041764768,
    C5: -0.000000014452093,
    C6: 0,
    C7: 6.5459673,
    C8: 6.54,
    C9: 14.526,
    C10: 0.7389,
    C11: 0.09486,
    C12: 0.4569,

    VAPlus: 1.4,
    VA: 1.6,
    VB: 1.8,
    VC: 2,
    VD: 2.2,

    NTAPlus: 83,
    NTA: 78,
    NTB: 73,
    NTC: 68,
    NTD: 63,

    DeltaPAPlus: 250,
    DeltaPA: 230,
    DeltaPB: 210,
    DeltaPC: 190,
    DeltaPD: 170,

    NgrefAPlus: 64,
    NgrefA: 62,
    NgrefB: 60,
    NgrefC: 57,
    NgrefD: 52,

    CoefAHigher: 4.56,
    CoefALower: 1.1,
    CoefBHigher: 10.5,
    CoefBLower: 2.6,

    PressureAtSeaLevel: 101325,
    GravityAcceleration: 9.80665,
    MolarMass: 0.02896968,
    SeaLevelTemperature: 288.16,
    UniversalGas: 8.314462618,
  };

  export default constants;